import { isDate as yt } from "../../util/code-utils.js";
import {
  convertMsToSeconds as h,
  dateFromUnixTimestamp as l,
  secondsAgo as ts,
  secondsInTheFuture as es,
} from "../../util/date-utils.js";
export default class sr {
  constructor(t, s, e, i) {
    (this.Tl = t),
      (this.Al = s),
      (this.comparator = e),
      (this._l = i),
      (this.Tl = t),
      (this.Al = s),
      (this.comparator = e),
      (this._l = i),
      this.Al === sr.Rl.Ml &&
        this.comparator !== sr.Il.Ll &&
        this.comparator !== sr.Il.Ol &&
        this.comparator !== sr.Il.Ul &&
        this.comparator !== sr.Il.Ql &&
        (this._l = l(this._l));
  }
  Bl(t) {
    let s = null;
    switch ((null != t && (s = t[this.Tl]), this.comparator)) {
      case sr.Il.Xl:
        return null != s && s.valueOf() === this._l.valueOf();
      case sr.Il.Fl:
        return null == s || s.valueOf() !== this._l.valueOf();
      case sr.Il.Kl:
        return null != s && typeof s == typeof this._l && s > this._l;
      case sr.Il.Ll:
        return this.Al === sr.Rl.Ml
          ? null != s && yt(s) && ts(s) <= this._l.valueOf()
          : null != s && typeof s == typeof this._l && s >= this._l;
      case sr.Il.Pl:
        return null != s && typeof s == typeof this._l && s < this._l;
      case sr.Il.Ol:
        return this.Al === sr.Rl.Ml
          ? null != s && yt(s) && ts(s) >= this._l.valueOf()
          : null != s && typeof s == typeof this._l && s <= this._l;
      case sr.Il.Yl:
        return (
          null != s &&
          "string" == typeof s &&
          typeof s == typeof this._l &&
          null != s.match(this._l)
        );
      case sr.Il.Zl:
        return null != s;
      case sr.Il.$l:
        return null == s;
      case sr.Il.Ul:
        return null != s && yt(s) && es(s) < this._l;
      case sr.Il.Ql:
        return null != s && yt(s) && es(s) > this._l;
      case sr.Il.Eu:
        return (
          null == s ||
          typeof s != typeof this._l ||
          "string" != typeof s ||
          null == s.match(this._l)
        );
    }
    return !1;
  }
  static fromJson(t) {
    return new sr(
      t.property_key,
      t.property_type,
      t.comparator,
      t.property_value,
    );
  }
  ss() {
    let t = this._l;
    return (
      yt(this._l) && (t = h(t.valueOf())),
      { k: this.Tl, t: this.Al, c: this.comparator, v: t }
    );
  }
  static Yn(t) {
    return new sr(t.k, t.t, t.c, t.v);
  }
}
(sr.Rl = { _u: "boolean", Hu: "number", Iu: "string", Ml: "date" }),
  (sr.Il = {
    Xl: 1,
    Fl: 2,
    Kl: 3,
    Ll: 4,
    Pl: 5,
    Ol: 6,
    Yl: 10,
    Zl: 11,
    $l: 12,
    Ul: 15,
    Ql: 16,
    Eu: 17,
  });
